import React from 'react';
import classes from './menuIcon.module.scss'
import PropTypes from 'prop-types';


function MenuIcon(props) {
    return (
        <button className={classes.wrapper} onClick={props.clickHandler}>
            <div className={classes.line}></div>
            <div className={classes.line}></div>
            <div className={classes.line}></div>
        </button>
    )
}

MenuIcon.propTypes = {
    clickHandler: PropTypes.func
}

export default MenuIcon

